import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ClinicalEvidencesTable from "../../../shared/CIVIC/ClinicalEvidencesTable";
import {
  countOccurrencesInArray,
  getVarsoUrl,
} from "../../../../common/helpers/helpers";
import Chart from "../../../../components/atoms/charts/Chart";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import CIViCGeneSummary from "./CIViCGeneSummary";
import HelperText from "../../../../components/atoms/HelperText";

const StyledChartsGroup = styled.div`
  display: flex;
  overflow-y: auto;
  justify-content: space-around;
  margin: 0 0 2rem 0;

  @media (max-width: 1200px) {
    justify-content: initial;
  }
`;

const Civic = ({ data }) => {
  if (data && Object.keys(data || {}).length > 0) {
    const collectDiseaseData = [];
    data?.items?.forEach((entry) => {
      collectDiseaseData.push(entry.disease);
    });
    const formattedData = [];
    const dataArray = countOccurrencesInArray(collectDiseaseData);
    Object.keys(dataArray).forEach((key) => {
      formattedData.push({ key, value: dataArray[key] });
    });

    const titleDetailsRight = data?.items[0] &&
      data?.items[0]?.gene_civic_url && (
        <div className="varsome-right">
          <small style={{ marginRight: "1rem" }}>
            <a href={getVarsoUrl(data.items[0].gene_civic_url)} target="_blank">
              View this on the CIViC site
            </a>
          </small>
        </div>
      );

    const content = (
      <div className="varsome-inner-container">
        <div className="varsome-horiz-flex">
          {data?.items[0]?.gene_description && (
            <CIViCGeneSummary summary={data?.items[0]?.gene_description} />
          )}
        </div>
        <StyledChartsGroup>
          <Chart data={formattedData} title="Disease Chart" />
        </StyledChartsGroup>
        <ClinicalEvidencesTable isGene={true} result={data} />
      </div>
    );

    return (
      <div className="varsome-result-fixed" data-testid="civic-component">
        <div className="varsome-container varsome-container__basic">
          <ComponentPanel
            title="CIViC"
            version={data?.version}
            url="https://civicdb.org/welcome"
            titleDetailsRight={titleDetailsRight}
            helperPopup={<HelperText fieldDescriptionKey="CIViC" />}
            content={content}
          />
        </div>
      </div>
    );
  }

  return null;
};

Civic.propTypes = {
  data: PropTypes.shape({
    version: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape()),
  }),
};

Civic.defaultProps = {
  data: null,
};

export default withErrorGuard(Civic, "WUSTL CIViC Gene", "CIViC");
